import moment from "moment";
import "moment/locale/pt-br";

interface StyleDate {
  default: string;
  long: string;
  datetime: string;
}

export default class Format {
  public static currency(currency: number | string): string {
    return (Number(currency) || 0).toLocaleString("pt-BR", { currency: "BRL", style: "currency" });
  }

  public static date(date: string, style?: keyof StyleDate) {
    const styleSelected: keyof StyleDate = style ? style : "default";
    const format: StyleDate = {
      default: "DD/MM/YYYY",
      long: "LL",
      datetime: "LLL",
    };

    return moment(date).format(format[styleSelected]).toString();
  }

  public static fullDate(date: string): string {
    const parsedFullDate = moment(date, "DD/MM/YYYY", true);

    if (parsedFullDate.isValid()) {
      return parsedFullDate.format("D [de] MMMM [de] YYYY");
    }

    const parsedMonthAndYear = moment(date, "MM/YYYY", true);

    return parsedMonthAndYear.isValid()
      ? parsedMonthAndYear.format("MMMM [de] YYYY")
      : date;
  }
}
